import { useState, useEffect } from "react";
import axios from "axios";
import styles from "./styles.module.scss";
import { Mail, HelpCircle, Users, FileText, Settings, User, Folder, ExternalLink, Clipboard, Info } from "feather-icons-react";

export function DashboardEmails() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Map of icon names to icon components
  const iconMap = {
    mail: Mail,
    "help-circle": HelpCircle,
    users: Users,
    "file-text": FileText,
    settings: Settings,
    user: User,
    folder: Folder,
    "external-link": ExternalLink,
    clipboard: Clipboard,
    info: Info,
  };

  const renderIcon = (iconName) => {
    const IconComponent = iconMap[iconName] || iconMap["mail"];
    return <IconComponent size={18} />;
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/admin-contacts");
      const sortedContacts = (response.data.data.data || []).sort(
        (a, b) => (a.order || 0) - (b.order || 0)
      );
      setContacts(sortedContacts);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className={styles.contactsLoading}>Loading contacts...</div>;
  }

  return (
    <div className={styles.contacts}>
      {contacts.map((contact) => (
        <a key={contact.id} href={`mailto:${contact.email}`} className={styles.contact}>
          <div className={styles.icon}>{renderIcon(contact.icon)}</div>
          <div className={styles.contactInfo}>
            <span className={styles.contactTitle}>{contact.name}</span>
            <span className={styles.contactEmail}>{contact.email}</span>
          </div>
        </a>
      ))}
    </div>
  );
}
